import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import PotmResultsModel from "../PlayerOfTheMatch/PotmResultsModel";
import PotmResultsResponseModel from "../PlayerOfTheMatch/PotmResultsResponseModel";
import PotmUserVotesModel from "../PlayerOfTheMatch/PotmUserVotesModel";
import PotmUserVotesResponseModel from "../PlayerOfTheMatch/PotmUserVotesResponseModel";

export default class PlayerOfTheMatchRemapper {
  public remapUserVotes = (data: any) => {
    const model = new PotmUserVotesResponseModel();
    model.meta = this.remapMeta(data.meta.pagination);
    model.data = data.data.map((value) => this.remapUserVoteModel(value));

    return model;
  };

  public remapResults = (data: any) => {
    const model = new PotmResultsResponseModel();
    model.meta = data.meta;
    model.data = data.data.map((value) => this.remapResultsModel(value));

    return model;
  };

  private remapMeta = (data: any) => {
    const model = new MetaModel();
    model.pagination.itemsPerPage = data.items_per_page;
    model.pagination.nextPageStartsAfter = data.next_page_starts_after;

    return model;
  };

  private remapUserVoteModel = (data: any) => {
    const model = new PotmUserVotesModel();
    model.matchId = data.match_id;
    model.playerId = data.player_id;
    model.createdAt = data.created_at;

    return model;
  };

  private remapResultsModel = (data: any) => {
    const model = new PotmResultsModel();
    model.teamId = data.team_id;
    model.playerId = data.player_id;
    model.votes = data.votes;
    model.winner = data.winner;

    return model;
  };
}
